import React, { useState } from "react";
import { toast } from "react-toastify";
import { inviteMember } from "../../services/memberService";
import styles from "./InviteModal.module.css";

export default function InviteModal({ onClose, onSuccess }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("MEMBER");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("E-mail é obrigatório."); return; }
    try {
      setLoading(true);
      await inviteMember(email, role);
      toast.success(`Convite enviado para ${email}`);
      onSuccess?.();
    } catch (err) {
      toast.error(err?.response?.data?.error ?? "Erro ao enviar convite.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2>Convidar membro</h2>
        <form onSubmit={handleSubmit}>
          <label className={styles.label}>
            E-mail
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="colaborador@empresa.com"
              className={styles.input}
              required
            />
          </label>
          <label className={styles.label}>
            Permissão
            <select value={role} onChange={(e) => setRole(e.target.value)} className={styles.input}>
              <option value="MEMBER">Membro</option>
              <option value="ADMIN">Admin</option>
            </select>
          </label>
          <div className={styles.actions}>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>Cancelar</button>
            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? "Enviando..." : "Enviar convite"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
